<template>
    <b-navbar toggleable="lg" type="dark" class="bg-primary">
        <b-navbar-brand href="/">
            <img id="logo" class="img-fluid" alt="AZORult Tracker" src="@/assets/images/AZORult-logo.png"/>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
             <b-navbar-nav>
                <b-nav-item to="/">Home</b-nav-item>
                <b-nav-item to="/doc">API</b-nav-item>
                <b-nav-item to="/about">About</b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-form @submit="preventDefault">
                    <b-form-input v-model="searchField" size="custom" class="mr-sm-2" placeholder="IP, domain, AS, ..."></b-form-input>
                    <b-button size="custom" class="my-2 my-sm-0" type="submit" @click="onSearch()" @click.ctrl="onSearch(true)">Search</b-button>
                </b-nav-form>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
export default {
    data() {
        return {
            searchField: ''
        }
    },
    methods: {
        preventDefault(evt) {
            evt.preventDefault()
        },
        onSearch(ctrl=false) {
            let { type, query } = this.$utils.parseSearchQuery(this.searchField)
            if (type) {
                if (ctrl) {
                    let route = this.$router.resolve(`/s/${type}/${encodeURIComponent(query)}`)
                    window.open(route.href, '_blank')
                }
                else {
                    this.$router.push(`/s/${type}/${encodeURIComponent(query)}`)
                      .catch(() => {})
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>

@media screen and (max-width: 980px) {
  #nav-collapse{
    text-align: center;
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .form-inline{
    display: block;
    padding: 5px;
  }
  input, button{
    display: inline;
  }
  .form-inline input[type="text"]{
      width: 100%;
  }
  .form-inline button{
      width: 100%;
  }
}
#logo {
    width: 75px;
}

.form-control-custom, .btn-custom {
    height: calc(2.2em + 0.5rem + 2px);
    padding: 0.25rem 0.8rem;
}

.navbar-brand {
  padding: 3px 3px 3px 0;
  box-sizing: content-box;
}
@media (min-width: 980px){
  .nav-item {
    width: 100px;
    text-align: center;
  }
}

.navbar-dark .navbar-nav .nav-link:active,
.navbar-dark .navbar-nav .nav-link:focus {
  border: none;
  background-image: linear-gradient(#6c5a35,#937a48);
  background-repeat: no-repeat;
}

.navbar-dark .navbar-nav .nav-link {
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 13pt;
}

.navbar .nav-link:hover {
  background-image: linear-gradient(#6c5a35);
  background-repeat: no-repeat;
}

.router-link-exact-active {
  background-image: linear-gradient(#6c5a35,#937a48);
  background-repeat: no-repeat;
}
</style>
